import React from 'react'
import { getRegisteredComponent } from './registeredComponents'
import { SchemaManager } from '../schemamanager/schemaManager'
import { IComponent, IDefaultStyles, IPropStyles } from '../schemamanager/types'
import { IDataProps } from './item'
import { IThemeColor } from '../schemamanager/themeColors'

export interface ElementProps {
    sm: SchemaManager
    comp: IComponent
    mergeStyles: (defaultStyles: IDefaultStyles) => IPropStyles
    themeColor: () => IThemeColor
    events: () => any
    addProps: () => any
    validateOnBlur: () => any
    data: IDataProps
    children?: any
}


export const Element = (props: ElementProps) => {
    const Elem = getRegisteredComponent(props.comp.type)
    if (!Elem) return <h4>Component not defined: "{props.comp.type}"!</h4>

    return (
        <Elem {...props} />
    )
}
